import styles from "./BottomLinks.css";
import classNames from "classnames";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";

const BottomLinks = ({ enableComplianceVariant, formatTranslation }) => {
  const termsLink = formatTranslation("loyalty_terms_privacy_hyperlink_copy", {
    termslink: `<a href='https://www.asos.com/terms-and-conditions/?ctaref=${encodeURIComponent(
      "t&cs - quick join overlay"
    )}'>${formatTranslation("loyalty_terms_link")}</a>`,
    privacypolicylink: `<a href='https://www.asos.com/privacy-policy/?ctaref=${encodeURIComponent(
      "privacy policy - quick join overlay"
    )}'>${formatTranslation("loyalty_privacy_link")}</a>`
  });

  const content = enableComplianceVariant
    ? `${termsLink}. ${formatTranslation("quick_join_overlay_opt_out_message")}`
    : termsLink;

  return (
    <div
      className={classNames("leavesden4", styles.bottomLinks)}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

BottomLinks.propTypes = {
  enableComplianceVariant: PropTypes.bool,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(BottomLinks);
